import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ShieldAlert, Lock, Mail } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@sentinel.io");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full bg-[#0B1220] border border-white/10 rounded-lg pl-10 pr-3.5 py-3 text-sm text-slate-100 placeholder-slate-500 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/30 transition-colors";

  return (
    <div className="min-h-screen flex items-center justify-center soc-grid bg-[#070B14] p-4">
      <div className="w-full max-w-md fade-up">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-cyan-500/10 border border-cyan-500/25 mb-4">
            <ShieldAlert className="w-8 h-8 text-cyan-400" />
          </div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">SAT</h1>
          <p className="eyebrow mt-2">ANTI-CHEATING SECURITY CONSOLE</p>
        </div>

        <form onSubmit={submit} className="card-soc p-7 glow-blue space-y-4">
          <div>
            <label className="eyebrow block mb-1.5">Email or Username</label>
            <div className="relative">
              <Mail className="w-4 h-4 text-slate-500 absolute left-3.5 top-3.5" />
              <input
                data-testid="login-email-input"
                className={field}
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@sentinel.io or client username"
              />
            </div>
          </div>
          <div>
            <label className="eyebrow block mb-1.5">Password</label>
            <div className="relative">
              <Lock className="w-4 h-4 text-slate-500 absolute left-3.5 top-3.5" />
              <input
                data-testid="login-password-input"
                className={field}
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>
          </div>

          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 bg-red-500/10 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-button"
            className="w-full bg-cyan-500 hover:bg-cyan-400 text-[#04121a] font-semibold rounded-lg py-3 transition-colors disabled:opacity-50"
          >
            {loading ? "Authenticating…" : "Access Console"}
          </button>
          <p className="text-xs text-slate-600 text-center pt-1">
            Admin demo: admin@sentinel.io / Sentinel@2026 · Clients sign in with the username given by their admin
          </p>
        </form>
      </div>
    </div>
  );
}
